import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { forwardRef, useEffect, useState } from "react";
import { InputProps } from "../common/inputProps";

const TextArea = forwardRef<HTMLDivElement, InputProps>(({
    error,
    placeholder,
    value = '',
    width = 300,
    height = 150,
    onChange,
    onBlur,
    name,
    disabled = false,
    required = false,
    rows = 4,
    maxRows,
    ...rest
  }, ref) => {

    const [inputValue, setInputValue] = useState(value as string);
    
    useEffect(() => {
      setInputValue(value as string);
    }, [value]);
    
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      const newValue = e.target.value;
      setInputValue(newValue);
      onChange?.(e as unknown as React.ChangeEvent<HTMLInputElement>);
    };

    // Estilos comuns para TextField multiline
    const textFieldStyle = {
      display: 'flex',
      alignItems: 'flex-start',
      width: "100%",
      backgroundColor: "#fff",
      "& .MuiInputBase-root": {
        minHeight: "100%",
      },
      "& .MuiOutlinedInput-inputMultiline": {
        padding: "14px",
      }
    };

    return (
      <Box sx={{ width: width }}>
        <TextField
          inputProps={{ ref }}
          label={placeholder}
          placeholder={placeholder}
          name={name}
          value={inputValue}
          onChange={handleChange}
          onBlur={onBlur}
          error={!!error}
          disabled={disabled}
          required={required}
          variant="outlined"
          fullWidth
          multiline
          rows={rows}
          maxRows={maxRows}
          className={`container-input__input ${error ? "container-input__input__error" : "container-input__input__default"}`}
          sx={textFieldStyle}
          {...rest}
        />
        {error && (<span className="container-input__input__error-message">{error.toString()}</span>)}
      </Box>
    );
  }
);

export default TextArea;